import React from "react";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { ISuggestionsListProps } from "./~types/SuggestionsListProps";
import Suggestion from "./suggestion/Suggestion";
import { IApplicationState } from "src/~store/models/ApplicationState";
import "./SuggestionsList.css";
import { TagType } from "../~types/models/SearchingTag";
import { connect } from "react-redux";

import { suggestionContactsSelector } from "../../../../contact/~store/selector";

const SuggestionsList = (props: ISuggestionsListProps) => {
  return (
    <Dropdown
      isOpen={props.isSuggestionsListVisible}
      toggle={() => undefined}
      direction="down"
      onKeyUp={(e) => {
        if (e.key === "Escape") {
          props.onCloseList();
        }
      }}
    >
      <DropdownToggle className="suggestions-list__toggle" tabIndex={-1} />
      {props.isSuggestionsListVisible && (
        <DropdownMenu
          className={`suggestions-list__menu ${
            props.suggestions?.[0]?.tagType === TagType.ClosingTag &&
            "closing-suggestions"
          }`}
        >
          {props.suggestions
            .filter((suggestion) => {
              switch (suggestion.tagType) {
                case TagType.OperationTag:
                case TagType.OpeningTag: {
                  return suggestion.value
                    .toLowerCase()
                    .includes(props.searchString.toLowerCase());
                }
                case TagType.ClosingTag:

                default: {
                  return true;
                }
              }
            })
            .map((s, i) => {
              return (
                <Suggestion
                  operatorClassName="suggestions-list__suggestion-operator"
                  className="suggestions-list__suggestion"
                  suggestion={s}
                  searchString={props.searchString}
                  searchingTag={props.searchingTag}
                  onSelected={(suggestion) => {
                    props.onSelected(suggestion);
                  }}
                  key={i}
                  keyValue={i}
                  operators={props.operators}
                  contacts={props.contacts}
                  suggestionContacts={props.suggestionContacts}
                  channels={props.channels}
                  suggestionItems={props.suggestionItems}
                />
              );
            })}
        </DropdownMenu>
      )}
    </Dropdown>
  );
};

const mapStateToProps = (state: IApplicationState) => {
  return {
    suggestionContacts: suggestionContactsSelector(state),
  };
};
export default connect(mapStateToProps)(SuggestionsList);
